<script setup>
// §8.4 DayRow — the atom of Home, Timesheets and Approvals.
// Columns: Date · status (ONE chip) · duration (tabular) · action.
// The blocker reason, when present, sits BENEATH the date as copy — never a
// second chip (§3.5.1). The action is a BUTTON beside the chip, because the
// chip itself is never clickable (§3.5.4).
import LStatusChip from './StatusChip.vue'
import LBlockerNote from './BlockerNote.vue'

defineProps({
  date: { type: String, required: true },
  state: { type: String, required: true },
  blocker: { type: String, default: null },
  logged: { type: String, default: '—' },
})
</script>

<template>
  <div class="row">
    <div class="date">
      <div class="d">{{ date }}</div>
      <LBlockerNote v-if="blocker" :icon="state !== 'notreq'">{{ blocker }}</LBlockerNote>
    </div>
    <div><LStatusChip :state="state" /></div>
    <div class="h num">{{ logged }}</div>
    <div class="a"><slot name="action" /></div>
  </div>
</template>

<style scoped>
.row {
  display: grid;
  /* Date takes the slack (and ellipsizes rather than wrapping); the other three
     are fixed so a standalone column header aligns with the rows. These widths
     are tighter than the raw chip/button sizes on purpose, so the row fits the
     showcase's two-column layout without wrapping. Columns shared with the
     DayRow header helper. */
  grid-template-columns: minmax(0, 1fr) 150px 64px 132px;
  align-items: center;
  gap: var(--sp-3);
  padding: var(--sp-3);
  border-radius: var(--r-sm);
  border-bottom: 1px solid var(--line-soft);
}
.row:last-child {
  border-bottom: 0;
}
.row:hover {
  background: var(--surface-sunken);
}
.date {
  min-width: 0;
}
.d {
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.h {
  font-weight: 600;
  color: var(--text-2);
  text-align: right;
}
.a {
  display: flex;
  justify-content: flex-end;
}
</style>
